import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-registration-complete',
    imports: [MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './registration-complete.component.html',
})
export class RegistrationCompleteComponent {
    externalLinks = ExternalLinks;
}
